




























import { defineComponent, nextTick } from '@vue/composition-api';
import FormInput from '@front-app/components/form/FormInput.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';

export default defineComponent({
	components: {
		FormInput,
		CtaButton,
	},
	props: {
		value: {
			type: String,
			default: '',
		},
		id: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			default: '#eeeeee',
		},
		enableClearButton: Boolean,
	},
	setup(props, ctx) {
		const clearColor = async () => {
			/**
			 * Due to how the color picker works, it defaults to black when set to an
			 * empty value. This emits an event setting the color to black, so we have
			 * to compensate by emitting an additional "clear" event.
			 */
			ctx.emit('input', '');
			await nextTick();
			ctx.emit('input', '');
		};
		const handleInput = (e: InputEvent) => {
			const target = e.target as HTMLInputElement | undefined;
			if (!target) {
				return;
			}
			ctx.emit('input', target.value || '');
		};
		return {
			clearColor,
			handleInput,
		};
	},
});
